import React from "react";
import PropTypes from "prop-types";
import ImportParts from "../CreateImportParts/ImportParts";

export default function CreateImportParts({ open, close }) {
  return <ImportParts open={open} close={close} />;
}

CreateImportParts.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/CreateImportParts/CreateImportParts.jsx